import React from 'react'
import { PlateFilter } from '~/api/backend/pages/culturesPageAPI'
import CloseIcon from '~/components/icons/CloseIcon'
import { snakeCaseToTitleCase } from '~/utils/string'
import { CultureStatusText } from './CultureStatusText'
import cs from './cultures_filter_pill.scss'

export function CulturesFilterPill({
  filter,
  onDeleteClick,
}: {
  filter: PlateFilter
  onDeleteClick: () => void
}) {
  let tokens: React.ReactNode[] = []

  if (filter.field === 'culture_status') {
    if (filter.operator && filter.operator.values) {
      if (filter.operator.values.length === 1) {
        tokens = [
          snakeCaseToTitleCase(filter.field),
          'is',
          <CultureStatusText status={filter.operator.values[0]} />,
        ]
      } else if (filter.operator.values.length >= 2) {
        tokens = [
          snakeCaseToTitleCase(filter.field),
          'is any of',
          <div className={cs.multiOptionToken}>
            {filter.operator.values.map((value, index) => (
              <React.Fragment key={value}>
                <CultureStatusText status={value} />
                {index !== filter.operator.values.length - 1 && (
                  <div className={cs.separator}>,</div>
                )}
              </React.Fragment>
            ))}
          </div>,
        ]
      } else {
        return null
      }
    } else {
      return null
    }
  }

  return (
    <div className={cs.filterPill}>
      {tokens.map((token, index) => (
        <div className={cs.token} key={index}>
          {token}
        </div>
      ))}
      <div className={cs.iconContainer} onClick={onDeleteClick}>
        <CloseIcon className={cs.icon} onClick={() => {}} />
      </div>
    </div>
  )
}
